import { render, staticRenderFns } from "./BlackListDialog.vue?vue&type=template&id=4dba0d54&scoped=true&"
import script from "./BlackListDialog.vue?vue&type=script&lang=js&"
export * from "./BlackListDialog.vue?vue&type=script&lang=js&"
import style0 from "./BlackListDialog.vue?vue&type=style&index=0&id=4dba0d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dba0d54",
  null
  
)

export default component.exports